__turbopack_context__.v({
  "splide__arrow": "VideoThumbnailCarousel-module-scss-module__sSOkTa__splide__arrow",
  "video_thumbnail_carousel": "VideoThumbnailCarousel-module-scss-module__sSOkTa__video_thumbnail_carousel",
});
